export default __webpack_public_path__ + "static/media/valx.145074ad.png";